import { useContext } from 'react';
import { UserFavoriteProductContext } from '../customContext/userFavoriteProductProvider';

export function useUserFavoriteProductCtx(){
    const ctx = useContext(UserFavoriteProductContext);
    if(!ctx){
        throw new Error("useUserFavoriteProductCtx must be used within the UserFavoriteProductProvider context")
    }
    return ctx
}